enum Mode {
  solid = 'solid',
  dotted = 'dotted'
}

export default Mode;
